import { atom } from 'recoil';
// import { STORE_KEYS } from '../keys';

export const settingsCurrentRouteAtom = atom<number>({
  key: 'settingsCurrentRoute',
  default: 0
});
